import type { Equipment } from '../game/world';

export interface ProfileShip {
  readonly shipId: number;
  readonly skinProductId: number;
  readonly decalProductId: number;
  readonly trailProductId: number;
  readonly tagProductId: number;
}

export interface ProfileShipPayload {
  readonly shipId?: number | null;
  readonly skinProductId?: number | null;
  readonly decalProductId?: number | null;
  readonly trailProductId?: number | null;
  readonly tagProductId?: number | null;
}

export type ProfileIconState = 'none' | 'other-ship' | 'stale' | 'current';

export function profileShipFrom(
  payload: ProfileShipPayload | null | undefined,
): ProfileShip | null {
  if (payload === null || payload === undefined || typeof payload.shipId !== 'number') return null;
  return {
    shipId: payload.shipId,
    skinProductId: payload.skinProductId ?? 0,
    decalProductId: payload.decalProductId ?? 0,
    trailProductId: payload.trailProductId ?? 0,
    tagProductId: payload.tagProductId ?? 0,
  };
}

export function equippedArrangement(equipment: Equipment, shipId: number): ProfileShip {
  return {
    shipId,
    skinProductId: equipment.shipSkins[shipId] ?? 0,
    decalProductId: equipment.decal,
    trailProductId: equipment.trail,
    tagProductId: equipment.tag,
  };
}

export function profileIconState(
  profile: ProfileShip | null,
  equipment: Equipment,
  shipId: number,
): ProfileIconState {
  if (profile === null) return 'none';
  if (profile.shipId !== shipId) return 'other-ship';

  const equipped = equippedArrangement(equipment, shipId);
  const same =
    equipped.skinProductId === profile.skinProductId &&
    equipped.decalProductId === profile.decalProductId &&
    equipped.trailProductId === profile.trailProductId &&
    equipped.tagProductId === profile.tagProductId;

  return same ? 'current' : 'stale';
}

export function profileIconLabel(state: ProfileIconState): string {
  switch (state) {
    case 'current':
      return 'Profile icon';
    case 'stale':
      return 'Update profile icon';
    case 'none':
    case 'other-ship':
      return 'Set as profile icon';
  }
}
